<template>
  <div class="ws-files">
    <b-collapse class="card" :open.sync="isOpen">
      <div
              slot="trigger"
              class="card-header"
              role="button">
        <p class="card-header-title">
          <ws-icon
            class="ws-member-icon ws-button__icon"
            name="items"
            color="#ccc"
            width="14"
            height="14"
          />
          <span style="display:inline-block; width: 10px"></span>
          <span>{{ title }}</span>
        </p>
        <div class="card-header-icon">
            <button class="ws-button button is-text">
                <ws-icon
                  class="ws-button__icon"
                  name="arrow-thin"
                  color="#ccc"
                  :class="{'ws-icon--left': !isOpen}"
                  :fill="false"
                  :title="$t('Свернуть/Развернуть')"
                  width="17"
                  height="11"
                />
            </button>
        </div>
      </div>
      <div class="card-content">
        <div class="content">
          <div class="ws-files__item">
            <template v-if="files && files.length">
              <file-download v-for="file in files" :file="file" :key="file.guid" @remove="removeFile"/>
            </template>
            <template v-else>
              <p class="has-text-centered has-text-grey is-size-4">{{ $t('Пока ничего нет')}}</p>
            </template>
          </div>
          <file-upload :category="category" :item-guid="reqGuid" @uploaded="uploadFile" :buttonLabel="buttonTitle"/>
          <b-loading :is-full-page="false" :active.sync="isPending" :can-cancel="true"></b-loading>
        </div>
      </div>
    </b-collapse>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: 'FilesManager',
  props: {
    reqGuid: String,
    category: String,
    title: String,
    buttonTitle: String
  },
  data () {
    return {
      isOpen: false,
      isPending: false,
      files: []
    }
  },
  computed: {
  },
  methods: {
    ...mapActions('profile/files', {
      getFileByRecId: 'getFileByRecId',
      removeFileByRecId: 'removeFileByRecId'
    }),
    uploadFile () {
      this.getFiles()
    },
    async getFiles () {
      this.isPending = true
      this.files = await this.getFileByRecId({
        'rec-guid': this.reqGuid,
        'category': this.category
      })
      this.isPending = false
    },
    async removeFile (e) {
      this.$buefy.dialog.confirm({
        title: this.$t(`Вы действительно хотите удалить файл ${e.file.file_name}?`),
        cancelText: this.$t('Отмена'),
        confirmText: this.$t('Удалить'),
        type: 'is-danger',
        onConfirm: async () => {
          try {
            this.isPending = true
            await this.removeFileByRecId({
              'rec-guid': this.reqGuid,
              'category': this.category,
              'file-guid': e.file.guid
            })
            this.getFiles()
          } catch (e) {
            // console.log(e)
          }
        }
      })
    }
  },
  async mounted () {
    this.getFiles()
  }
}
</script>

<style lang="scss">
  .ws-files {
    position: relative;
    // padding: 20px 0;
    &__item {
      margin-bottom: 20px;
      .file-download {
        margin-bottom: 10px;
        padding-bottom: 10px;
        border-bottom: 1px solid #eee;
      }
    }
  }
</style>
